module.exports = __webpack_public_path__ + "img/EXPORT.0a284a15.svg";